module.exports = __webpack_public_path__ + "img/6.08472462.jpg";